module.exports = __webpack_public_path__ + "media/images/flags/16/Singapore-4fe0833c012769268146a3f8ff06c5ec.png";